export const DESIGN_STAGES = ["selecting", "rendering", "finishing", "saving"] as const;
export type DesignStage = typeof DESIGN_STAGES[number];
export type ImageStage = Extract<DesignStage, "rendering" | "finishing">;

export interface DesignProgress {
  stage: "preparing" | DesignStage | "complete";
  skipped: ImageStage[];
  updated_at: string;
}

export function designProgress(stage: DesignProgress["stage"], skipped: ImageStage[] = []): DesignProgress {
  return { stage, skipped: [...skipped], updated_at: new Date().toISOString() };
}

export function stageState(stage: DesignStage, progress?: DesignProgress): "pending" | "current" | "done" | "skipped" {
  if (!progress) return "pending";
  if (progress.skipped.includes(stage as ImageStage)) return "skipped";
  if (progress.stage === stage) return "current";
  if (progress.stage === "complete") return "done";
  return DESIGN_STAGES.indexOf(stage) < DESIGN_STAGES.indexOf(progress.stage as DesignStage) ? "done" : "pending";
}
